import { cn } from "@/lib/utils";

const badgeVariants = {
  default: 'bg-white/[0.08] text-soft-silver',
  primary: 'bg-electric-ice-blue/20 text-electric-ice-blue',
  success: 'bg-cool-mint/20 text-cool-mint',
  warning: 'bg-soft-amber/20 text-soft-amber',
  error: 'bg-signal-red/20 text-signal-red',
  muted: 'bg-white/[0.05] text-muted-text',
};

const sizeVariants = {
  sm: 'px-2 py-0.5 text-[10px]',
  default: 'px-3 py-1 text-xs',
  lg: 'px-4 py-1.5 text-sm',
};

export const BadgePill = ({ 
  children, 
  variant = 'default',
  size = 'default',
  className 
}) => {
  return (
    <span 
      className={cn(
        "inline-flex items-center rounded-[20px] font-medium whitespace-nowrap transition-colors duration-200",
        badgeVariants[variant],
        sizeVariants[size],
        className
      )}
      data-testid="badge-pill"
    >
      {children}
    </span>
  );
};

export default BadgePill;
